// extracted by css-extract-rspack-plugin
export default {"client":"MainOffice__client--sm2ga","link":"MainOffice__link--cniAI","email":"MainOffice__email--Z93sB"};